
//AlpineJs
import Alpine from "alpinejs"
import focus from "@alpinejs/focus"
import collapse from "@alpinejs/collapse"
Alpine.plugin(collapse)
Alpine.plugin(focus)
Alpine.start()

// @ts-ignore
var mixitup = require('mixitup');
document.addEventListener("DOMContentLoaded", function (event) {

    //Prevent scroll when menu is open
    document.querySelector("#menuToggle").addEventListener("click", function () {
        document.querySelector('body').classList.toggle('prevent-scroll');
        event.stopPropagation();

    });

    function removeClass(e: any) {
        const navContainer = document.querySelector('.nav-container');
        const path = e.path || (e.composedPath && e.composedPath());
        if (path && !path.includes(navContainer)) {
            document.querySelector('body').classList.remove('prevent-scroll');
        }
    }

    document.addEventListener('click', removeClass);

    //decrease menu-size on scroll
    const menu = document.querySelector("#navbar");
    document.addEventListener("scroll", () => {

        // use document.documentElement for chrome, firefox, ie or opera
        // and document.body for safari since that's where overflow is set in those browsers
        if (document.documentElement.scrollTop > 0)
            menu.classList.add("menu--alt");
        else
            menu.classList.remove("menu--alt");

    });

    //MixItUp filtering on event page
    const mixContainer = document.getElementById('mixContainer');
    if (mixContainer) {
        var mixer = mixitup(mixContainer, {
            controls: {
                toggleDefault: 'all'
            }
        });
    }

    //FormPreview AltText
    if (document.getElementById('SubmitEvent')) {

        //Save image in local storage to prevent content from dissapearing while moving to next step
        const sessionStorageEl = sessionStorage.getItem("imgData");
        if (sessionStorageEl) {
            const preview = document.getElementById('imagePreview');
            preview.setAttribute('src', sessionStorageEl);

        }

        const descSessionStorageEl = sessionStorage.getItem("descStorage");
        if (descSessionStorageEl) {
            const result = document.getElementById('description');
            result.textContent = descSessionStorageEl;
        }

        const titleSessionStorageEl = sessionStorage.getItem("titleStorage");
        if (titleSessionStorageEl) {
            const result = document.getElementById("eventTitle");
            result.textContent = titleSessionStorageEl;
        }

        const userAltTextEl = document.querySelector('input[data-alias="userAltText"]') as HTMLInputElement;
        if (userAltTextEl) {
            const result = document.getElementById('userAlt') as HTMLParagraphElement;
            result.textContent = userAltTextEl.value;

            userAltTextEl.addEventListener('change', (event) => {
                let eventTarget = event.target as HTMLInputElement;
                result.textContent = eventTarget.value;
            });

        }

        //render preview of event title
        const eventTitleEl = document.querySelector('input[data-alias="eventTitle"]') as HTMLInputElement;

        if (eventTitleEl) {
            const result = document.getElementById('eventTitle') as HTMLHeadingElement;
            result.textContent = eventTitleEl.value;

            eventTitleEl.addEventListener('keyup', (event) => {
                let eventTarget = event.target as HTMLInputElement;
                result.textContent = eventTarget.value;
            });

            eventTitleEl.addEventListener('change', (event) => {
                sessionStorage.setItem("titleStorage", result.textContent);
                console.log("local", sessionStorage)
            });
        };

        //Render preview of event description
        const userDescriptionEl = document.querySelector('textarea[data-alias="userDescription"]') as HTMLInputElement;
        console.log("test1", userDescriptionEl);
        if (userDescriptionEl) {
            const result = document.getElementById("description") as HTMLParagraphElement;
            result.textContent = userDescriptionEl.value;

            userDescriptionEl.addEventListener('keyup', (event) => {
                let eventTarget = event.target as HTMLInputElement;
                result.textContent = eventTarget.value;

            });

            userDescriptionEl.addEventListener('change', (event) => {
                sessionStorage.setItem("descStorage", result.textContent);
                console.log("local", sessionStorage)
            });

        };

        //Render preview image from fileupload
        const eventImageEl = document.querySelector('input[data-alias="formEventImage"]') as HTMLInputElement;

        const previewPhoto = () => {
            console.log("input", eventImageEl)
            console.log("input value", eventImageEl.value)
            console.log("input value2", eventImageEl.value.split('\\').pop().split('/').pop())
            document.getElementById("fileNameInput").textContent = eventImageEl.value.split('\\').pop().split('/').pop() as any;

            var red = document.getElementById("inputImageDiv") as HTMLDivElement;
            red.style.display = "block";
            const file = eventImageEl.files;
            if (file) {
                const fileReader = new FileReader();
                const preview = document.getElementById('imagePreview');
                console.log("bild", preview);
                let eventTarget = event.target as HTMLInputElement;


                fileReader.onload = function (event: ProgressEvent<FileReader>) {
                    preview.setAttribute('src', event.target?.result as string);
                    sessionStorage.setItem("imgData", event.target?.result as string);


                }
                fileReader.readAsDataURL(file[0]);
            }

        }
        if (eventImageEl) {
            eventImageEl.addEventListener("change", previewPhoto);
            eventImageEl.addEventListener("click", (event) => {
                sessionStorage.removeItem(sessionStorageEl);
            });

        }

        const submitButton = document.getElementById('eventLastSubmit');
        if (submitButton) {
            submitButton.addEventListener('click', () => {
                sessionStorage.clear();
            })
        }

    };

    //Indicate which form-page the user is on
    const descEl = document.getElementById('3413a96f-8680-4048-81d8-e329e025d5d2');
    const descClassEl = document.getElementById('liDescription');
    

    if (descEl != null) {
        descClassEl.classList.add('active-li');
    }

    const addressEl = document.getElementById('8fcd6540-a029-435b-94f1-a338a7af2862');
    const placeClassEl = document.getElementById('liPlace');

    if (addressEl != null) {
        placeClassEl.classList.add('active-li');
    }

    const contactEl = document.getElementById('44b437e0-bfcc-4327-f616-225976bc6bdf');
    const contactClassEl = document.getElementById('liContact');
    const contactPersonEl = document.getElementById('personalInfo')

    if (contactEl != null) {
        contactClassEl.classList.add('active-li');
        contactPersonEl.classList.add('display-info');
    }

});